import { validateInstruction } from '../../../components/BookingInstructions/InstructionInput';
import {Box,Button,Checkbox, FormControl,FormControlLabel,FormGroup , FormHelperText, Grid, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { Controller,useForm } from 'react-hook-form'
import Swal from 'sweetalert2';
import { BookingService } from '../Service';
import { useParams } from 'react-router-dom';
import { BookingDataContext, StepperDataContext } from './AddBooking';

const Payment = () => {
    // const {id} = useParams();
    const {bookingInProgressData,paymentDetails,supportInstructions} = useContext(BookingDataContext);
    const {activeStep, handleNext,handleBack,handleComplete,setBookingResponseDetails} = useContext(StepperDataContext);  
    const { control, handleSubmit, setValue, formState: { errors ,isDirty},watch,reset } = useForm({
        mode: "onChange",
        defaultValues:{
            paymentMode:paymentDetails.paymentMode||'',
        }
    });
    const completeBooking=async()=>{
        const instructionValidation = validateInstruction(supportInstructions || '');
        if (instructionValidation !== true) {
            await Swal.fire({ icon: 'error', text: instructionValidation });
            return false;
        }
        const result = await Swal.fire({
          text: "Do you want to Confirm Booking now?",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Confirm now!',
          cancelButtonText: 'No, Cancel',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
        });
        if (result.isConfirmed){
            try {
                // Show loading state
                Swal.fire({
                    title: 'Processing...',
                    text: 'Please wait while we processing your booking request',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
        
                // Make the API call
                const bookingResponse = await BookingService.confirmBooking(
                    {
                        ...(supportInstructions?.trim() ? { supportInstructions } : {}),
                        "bookingId": bookingInProgressData?.id,    
                        "paymentType": "CASH", 
                        "paymentTypeDetils": {

                        },
                        "razorPaymentDetail": {}
                    }
                );

        
                // Close loading dialog and show success/error message
                if (bookingResponse.success == '1') {
                setBookingResponseDetails({status:'true',message:'booking successfull',data:bookingResponse.data})
                await Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: bookingResponse.message || 'Service Booking successfull',
                    timer: 1500
                });
                // handleComplete();
                handleNext();
                return true;
                } else {
                    await Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: bookingResponse?.message || 'Something Went Wrong ... Booking failed'
                    });
                    return false;
                }
        
            } catch (error) {
                // console.error("Error in Booking:", error);
                await Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'An error occurred while booking'
                });
                return false;
            }
        }else {
          return false;
        }
      }
  return (
    <Box component={'form'} onSubmit={handleSubmit(completeBooking)} sx={{pb:'1%'}}>
        <Grid container spacing={2} >
            <Grid item lg={9} xs={12} sx={{margin:'auto'}}>
                <Grid container spacing={2} >
                {/* ............left section................... */}
                    <Grid item xs={12} lg={5}>
                        <Grid container>
                            <Grid item xs={12} sx={{my:'1%'}}>
                                <Grid container sx={{mb:'1%'}}>
                                    <Grid item lg={7} xs={12}>
                                        <Typography sx={{fontWeight:'600'}}>Payment Method :</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item lg={12} xs={12}>
                                    <Controller
                                        name="paymentMode"
                                        control={control}
                                        rules={{ required: "Please select paymentMode" }}
                                        render={({ field, fieldState: { error } }) => (
                                            <FormControl sx={{ minWidth: "100%" }} component="fieldset" error={!!error}>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={field.value === 'pay after service'}
                                                                onChange={(e) => {
                                                                    // If checkbox is checked, set to 'pay after service'
                                                                    // If unchecked, set to empty string
                                                                    const newValue = e.target.checked ? 'pay after service' : '';
                                                                    field.onChange(newValue);
                                                                    setValue('paymentMode', newValue);
                                                                }}
                                                            />
                                                        }
                                                        label="Pay After Service"
                                                    />
                                                </FormGroup>
                                                {error && <FormHelperText>{error.message}</FormHelperText>}
                                            </FormControl>
                                        )}
                                    />

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        {/* =======Form Action Button Section ========*/}
        <Box sx={{display:'flex',justifyContent:'center',gap:2,mt:'.5%'}}>
            <Button size='small' sx={{textTransform:'capitalize'}} disabled={activeStep === 0} onClick={handleBack} variant='contained' color='secondary'>Back</Button>
            <Button 
                size='small' sx={{textTransform:'capitalize'}} 
                disabled={!watch('paymentMode') || !isDirty} 
                type='submit' 
                // onClick={handleNext}
                variant='contained' color='primary'
            >
                {/* Submit & Next */}
                confirm Booking
            </Button>
        </Box>
    </Box>
  );
}

export default Payment;
